const chosenValues = (values, param) => [].concat(values[param] ?? []).filter((value) => value !== "" && value !== null);

export const classesEmbedUrl = (baseUrl, filters, values = {}) => {
  const url = new URL(baseUrl);
  filters.forEach(({ param }) => {
    chosenValues(values, param).forEach((value) => url.searchParams.append(param, value));
  });
  return url.toString();
};

const shortHash = (text) => {
  let hash = 0x811c9dc5;
  Array.from(text).forEach((char) => {
    hash = Math.imul(hash ^ char.codePointAt(0), 0x01000193);
  });
  return (hash >>> 0).toString(36);
};

export const classesEmbedIframeId = (venueId, filters, values = {}) => {
  const chosen = filters.filter(({ param }) => chosenValues(values, param).length > 0);
  if (chosen.length === 0) return `od-classes-${venueId}`;

  const slug = chosen.map(({ label, param }) => `${label}-${chosenValues(values, param).join("-")}`)
    .join("-")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, "-")
    .replace(/^-+|-+$/g, "");
  const fingerprint = shortHash(chosen.map(({ param }) => chosenValues(values, param).map((value) => `${param}=${value}`).join("&")).join("&"));
  return slug ? `od-classes-${venueId}-${slug}-${fingerprint}` : `od-classes-${venueId}-${fingerprint}`;
};
